import {Form, Input} from "@bezlimit/bezlimit-ui";
import {FormItemProps} from "antd";
import _ from "lodash";
import {useTranslation} from "react-i18next";
import NumberFormat from "react-number-format";

export default function QuantityEnvelopesField({title, props}: IProps) {
    const {t} = useTranslation();

    const onInput = (e: any) => {
        if (e.target.value.length > 2) e.target.value = e.target.value.slice(0, 2);
    };

    const onKeyDown = (e: any) => {
        if (
            (_.inRange(e.keyCode, 48, 58) && !e.shiftKey) ||
            _.isEqual(e.keyCode, 8) ||
            (_.inRange(e.keyCode, 96, 106) && !e.shiftKey)
        ) {
        } else {
            e.preventDefault();
        }
    };

    return (
        <Form.Item {...props} className="field-fio" name="envelope_count">
            <NumberFormat<any>
                customInput={Input}
                title={t(title)}
                format={(value) => {
                    const code = value.substring(0, 2);
                    const nums1 = value.substring(4, 8);

                    return `${code}${nums1 ? ` ${nums1}` : ""}`;
                }}
                onInput={onInput}
                onKeyDown={onKeyDown}
            />
        </Form.Item>
    );
}

interface IProps extends FormItemProps<any> {
    title: string;
    props?: FormItemProps<any>;
}
